/*
    Created by Phat Hoang Pham
    phat@launchdeck.org
*/

import React, { PureComponent } from 'react';
import {
    View,
    Text,
    TouchableOpacity
} from 'react-native-web';
import PropTypes from 'prop-types';
import * as Animatable from 'react-native-animatable';
import moment from 'moment';
import { DatePickerModal } from 'react-native-paper-dates';
import { toast } from 'react-hot-toast';

// Custom Components
import { Button, InScreenModal, NavBar } from '../../components';

// Utils
import { setCloseDate } from '../../modules';
import { showAppError } from '../../utils/util_helpers';

// Configs
import GLOBAL from '../../configs/config_global';
import { getGlobalState, STATE_KEYS } from '../../configs/config_state';

export class TimeOffModal extends PureComponent {
    // region Props
    static propTypes = {
        currentOffReasonID: PropTypes.number,
        returnDate: PropTypes.number,
        onTimeOffUpdated: PropTypes.func
    };

    static defaultProps = {
        currentOffReasonID: 1,
        returnDate: moment().unix(),
        onTimeOffUpdated: () => {}
    };
    // endregion

    // region Constructor
    state = {
        showModal: false,
        showReturnDatePicker: false,
        returnDate: this.props.returnDate,
        currentOffReasonID: this.props.currentOffReasonID,
        isLoadingOffDate: false
    };

    offDateData = {
        1: 'Open',
        2: 'On Vacation',
        3: 'Maintenance',
        4: 'Winter Season'
    };
    // endregion

    // region Functions
    showModal = () => this.setState({ showModal: true });
    hideModal = () => this.setState({ showModal: false, startLoadingComp: false });
    // endregion

    // region Function - Go Set Time Off
    goSetTimeOff = () => {
        this.setState({ isLoadingOffDate: true });
        setCloseDate(getGlobalState(STATE_KEYS.TRUCK_DATA)?.id, moment.unix(this.state.returnDate).format('YYYY-MM-DD'), this.state.currentOffReasonID)
            .then(() => {
                this.setState({ isLoadingOffDate: false, startLoadingComp: false, showModal: false });
                this.props.onTimeOffUpdated(this.state.returnDate, this.state.currentOffReasonID);
                toast('Time off has been set');
            })
            .catch((error) => {
                this.setState({ isLoadingOffDate: false });
                showAppError(error);
            });
    }
    // endregion

    // region Render Time Off Item
    renderTimeOffItem(item, key) {
        const isChosen = (this.state.currentOffReasonID === Number(key));

        return(
            <TouchableOpacity
                key={`offDateItem_${key}`}
                onPress={() => !isChosen && this.setState({ currentOffReasonID: Number(key) })}
                style={{ paddingVertical: 18, paddingHorizontal: 32, borderBottomWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER, backgroundColor: 'white' }}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Text style={{ color: 'black', fontWeight: '500', fontSize: 18, flex: 1 }}>
                        {item}
                    </Text>

                    {/* Select Indicator */}
                    <View style={{
                        width: 24, height: 24, marginLeft: 16,
                        borderRadius: 16, borderWidth: 2, borderColor: isChosen ? GLOBAL.COLOR.MAIN : GLOBAL.COLOR.TEXT_LIGHT_GRAY,
                        backgroundColor: isChosen ? GLOBAL.COLOR.MAIN : 'white',
                        alignItems: 'center', justifyContent: 'center'
                    }}>
                        {isChosen && <View style={{ width: 8, height: 8, borderRadius: 6, backgroundColor: 'white' }}/>}
                    </View>
                </View>

                {/* Return Date Selector */}
                {
                    (isChosen && Number(key) !== 1) &&
                    <View style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', marginTop: 24 }}>
                        <Text style={{ fontSize: 16, color: GLOBAL.COLOR.BASIC.NEUTRAL_DARK_GREY, flex: 1 }}>
                            Work off until
                        </Text>

                        <TouchableOpacity onPress={() => this.setState({ showReturnDatePicker: true })}>
                            {this.renderPicker()}

                            <Text style={{ color: GLOBAL.COLOR.BASIC.UI_BLUE, fontWeight: '500', fontSize: 16 }}>
                                {moment.unix(this.state.returnDate).format('MMMM D, YYYY')}
                            </Text>
                        </TouchableOpacity>
                    </View>
                }
            </TouchableOpacity>
        );
    }
    // endregion

    // region Render Picker
    renderPicker() {
        return(
            <DatePickerModal
                locale={'en'}
                mode={'single'}
                visible={this.state.showReturnDatePicker}
                date={moment.unix(this.state.returnDate).toDate()}
                saveLabelDisabled={true}
                onChange={({ date }) => this.setState({ showReturnDatePicker: false, returnDate: moment(date).unix() })}
                onDismiss={() => this.setState({ showReturnDatePicker: false })}
            />
        )
    }

    // endregion

    // region MAIN RENDER FUNCTION
    render() {
        const { currentOffReasonID, returnDate } = this.props;
        return(
            <InScreenModal
                visible={this.state.showModal}
                onShow={() => this.setState({ currentOffReasonID, returnDate }, () => this.setState({ startLoadingComp: true }))}>
                {/* Content */}
                <View style={{ flex: 1, width: '100%', backgroundColor: 'white' }}>
                    {/* Nav Bar */}
                    <NavBar
                        title={'Time Off Setting'}
                        ignoreTopBarHeight={true}
                        hideBorder={true}
                        leftButtonOnPress={this.state.isLoadingOffDate ? null : this.hideModal}
                    />

                    {/* Notice Line */}
                    <Text style={{ fontSize: 16, color: GLOBAL.COLOR.BASIC.NEUTRAL_GREY, textAlign: 'center', margin: 24, marginTop: 0, lineHeight: 22 }}>
                        On vacation or dealing with some maintenance issues? Set your return date and reason so we can let consumers know!
                    </Text>

                    {/* Selections */}
                    {
                        this.state.startLoadingComp &&
                        <Animatable.View
                            animation={'fadeIn'}
                            style={[{ borderTopWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER, width: '100%' }, this.state.isLoadingOffDate && { opacity: 0.7 }]}>
                            {Object.keys(this.offDateData).map((key) => this.renderTimeOffItem(this.offDateData[key], key))}
                        </Animatable.View>
                    }

                    <View style={{ flex: 1 }}/>

                    {/* Apply Button */}
                    <Button
                        onPress={this.goSetTimeOff}
                        style={{ marginHorizontal: 24, marginBottom: 24 }}
                        text={'Save'}
                        textStyle={{ color: 'white' }}
                        locked={(currentOffReasonID === this.state.currentOffReasonID) && moment.unix(this.props.returnDate).isSame(moment.unix(this.state.returnDate), 'day')}
                        isLoading={this.state.isLoadingOffDate}
                        loadingText={'Saving time off setting'}
                    />

                    {/* Date Picker */}
                    {this.renderPicker()}
                </View>
            </InScreenModal>
        );
    }
    // endregion
}
